import { BLOG_NEWS_TYPE } from '@/helpers';
import ImageCard from '@/components/@general/ImageCard/index.vue';

export default {
  name: 'NewsCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: BLOG_NEWS_TYPE.NEWS
    }
  },
  data() {
    return {};
  },
  components: { ImageCard },

  created() {},
  mounted() {},
  computed: {},

  methods: {}
};
